/*************B2C*****************/
import Accordion from "react-bootstrap/Accordion";
import SpinnerBootrap from "components/SpinnerBootrap";
import RequestError from "components/RequestError";
import OrderScheduleService from "components/services/OrderScheduleService";
import OrderScheduleServiceB2B from "components/services/OrderScheduleServiceB2B";
import TarjetasTokenService from "components/services/TarjetasTokenService";
import PagoTarjetasTokenService from "components/services/PagoTarjetasTokenService";
import Order from "components/services/OrderV9";
import React, { useEffect, useState } from "react";
import { HelpHttp } from "helpers/HelpHttp";
import { trackPromise } from "react-promise-tracker";
import ValidateQuotaService from "components/services/ValidateQuotaService";
import CustomerAccountService from "components/services/CustomerAccountService";
import PortabilityService from "components/services/PortabilityService";
import MinPrePostService from "components/services/MinPrePostService";
import CheckTermsService from "components/services/CheckTermsService";
import RSResourceOrderReserveService from "components/services/RSResourceOrderReserveService";
import ValidateReserve from "components/services/ValidateReserveService";
import GeneratePinService from "components/services/generatePinService";
import ValidatePinService from "components/services/validatePinService";
import GenerateOtpService from "components/services/generateOtpService";
import ValidateOtpService from "components/services/validateOtpService";
import ValidateFormService from "components/services/ValidateFormService";
import FormasPagoService from "components/services/FormasPagoService";
import MinPrePosService from "components/services/minPrePosService";
import ConsultFraudListService from "components/services/consultFraudListService";
import CapacityHService from "components/services/capacityH";
import CreateOrderHService from "components/services/createOrderH";
import Transunion from "components/services/Transunion";
import VerifOpDonSevice from "components/services/VerifOpDonSevice";
import OfferValidate from "components/services/OfferValidate";
import SkuSonGuest from "components/services/SkuSonGuest";
import InitialPaymentService from "components/services/initialPaymentService";
import FinancialTermsService from "components/services/financialTermsService";
import ValidateEmailcustomerService from "components/services/validateEmailcustomerService";
import ValidateDocumentCustomerService from "components/services/validateDocumentCustomerService";
import CustomerLoginServer from "components/services/customerLoginService";
import RecoveryPassServer from "components/services/recoveryPassServer";
import ChangePassServer from "components/services/changePassServer";
import CustomerIdentityValidateService from "components/services/CustomerIdentityValidateService";
import CustomerIdentityExpeditionService from "components/services/CustomerIdentityExpeditionService";
import AuthenticaEntAdminCreateCustomerService from "components/services/AuthenticaEntAdminCreateCustomerService";
import NormalizationService from "components/services/NormalizationService";
import GetPaymentTokenService from "components/services/GetPaymentTokenService";
import PostShoppingCartService from "components/services/PostShoppingCartService";
import CustomerPhoneService from "components/services/CustomerPhoneService";
import GenerateTokenService from "components/services/generateTokenService";
import NotifySalesService from "components/services/NotifySalesService";
import ParamsPatchMASofisService from "components/services/ParamsPatchMASofisService";
import ParamsGetMASofisService from "components/services/ParamsGetMASofisService";
import GeographicAddressService from "components/services/geographicAddressService";
import ManageQuotaService from "components/services/ManageQuotaService";
import MSProMetrSKUTerminalsService from "components/services/msProMetrSKUTerminalsService";
import AuthTokenNotificationService from "components/services/AuthTokenNotificationService";
import NotificationCustomerChannelService from "components/services/NotificationCustomerChannelService";
import PaymentService from "components/services/PaymentService";
import PaymentServiceB2B from "components/services/PaymentServiceB2B";
import PortabilidadNip from "components/services/PortabilidadNip";
import CalculateDatesWindowChange from "components/services/CalculateDatesWindowChange";
import SegmentService from "components/services/SegmentService";
import ProductPriceService from "components/services/ProductPriceService";
import Normalizationb2BService from "components/services/NormalizationB2BService";
import GetCitiesService from "components/services/GetCitiesService";
import GetAdressTypesService from "components/services/GetAdressTypesService";
import GetGroupingsService from "components/services/GetGroupingsService";
import GetPropertyTypesService from "components/services/GetPropertyTypesService";
import OrderReserverService from "components/services/OrderReserverService";
import TrackingOrderService from "components/services/TrackingOrderService";
import WareHouses from "components/services/WareHousesService";
import PortabilityListService from "components/services/PortabilityListService";
import CheckNipStatusService from "components/services/CheckNipStatusService";
import IdClaroVerifyService from "components/services/IdClaroVerifyService";
import RSProOrdeProdOrderecommerceService from "components/services/RSProOrdeProdOrderecommerceService";
import RSPartyBillRecvMgTTService from "components/services/RSPartyBillRecvMgTTService";
import RSParBillRecvMgServService from "components/services/rSParBillRecvMgServService";
import GetBillCyclesService from "components/services/GetBillCyclesService";
import GeographicAddressValidationService from "components/services/GeographicAddressValidationService";
import CustomerRiskProfileService from "components/services/CustomerRiskProfileService";
import ValidatePortabilityPPService from "components/services/ValidatePortabilityPPService";
import PortabilityInService from "components/services/b2cSalesforce/PortabilityInService";
import RequestNIPService from "components/services/b2cSalesforce/RequestNIPService";
import GetSimulationService from "components/services/b2cSalesforce/GetSimulationService";
import CreateAccountManagementSOAP from "components/services/CreateAccountManagementSOAP";
import ProductListPromiseService from "components/services/ProductListPromiseService";
import SaveNipService from "components/services/SaveNipService";
import StatusNipService from "components/services/StatusNipService";
import OpenIdConnectTokenService from "components/services/OpenIdConnectTokenService";
import TokenOauthTwoV1Service from "components/services/TokenOauthTwoV1Service";
import RequestsFiltersService from "components/services/RequestsFiltersService";
import MSCusAccoInfoEcomService from "components/services/MSCusAccoInfoEcomService";
import ConsultEventsStatusService from "components/services/ConsultEventsStatusService";
import RSBusInteQryCondbyCredService from "components/services/RSBusInteQryCondbyCredService";
import RSBusInteAskSurCrService from "components/services/RSBusInteAskSurCrService";

/*************B2B*****************/
import SendOrderB2BService from "components/services/sendOrderB2BService";
import ConsultFraudListB2BService from "components/services/ConsultFraudListB2BService";
import SkuChildB2BService from "components/services/SkuChildB2BService";
import GetCitiesB2BService from "components/services/GetCitiesB2BService";
import GetAddressTypesB2BService from "components/services/GetAddressTypesB2BService";
import GetGroupingsB2BService from "components/services/GetGroupingsB2BService";
import GetPropertyTypesB2BService from "components/services/GetPropertyTypesB2BService";
import SelfCareManagementLoginUsuarioB2BService from "components/services/SelfCareManagementLoginUsuarioB2BService";
import SelfCareManagementRecuperarContraseñaUsuarioB2BService from "components/services/SelfCareManagementRecuperarContrasenaUsuarioB2BService";
import SelfCareManagementCambiarContraseñaUsuarioB2BService from "components/services/SelfCareManagementRecuperarContrasenaUsuarioB2BService";
import SelfCareManagementModificarPerfilUsuarioB2BService from "components/services/SelfCareManagementModificarPerfilUsuarioB2BService";
import SelfCareManagementConsultarPerfilUsuarioB2BService from "components/services/SelfCareManagementConsultarPerfilUsuarioB2BService";
import SelfCareManagementSolicitarTokenAutenticacionSSOB2BService from "components/services/SelfCareManagementSolicitarTokenAutenticacionSSOB2BService";
import ValidateUserB2BService from "components/services/ValidateUserB2BService";
import SendEmailB2BService from "components/services/SendEmailB2BService";
import AuthTokenB2BService from "components/services/AuthTokenB2BService";

/*************B2B2C*****************/
import B2B2CMsSecurityEntityAuthUserService from "components/services/b2b2c/B2B2C_MsSecurityEntityAuthUserService";
import B2B2COrganizationProfileAgentService from "components/services/b2b2c/B2B2C_OrganizationProfileAgentService";
import B2B2COrganizationProfileCreditLimitService from "components/services/b2b2c/B2B2C_OrganizationProfileCreditLimitService";
import B2B2CValidatePricePrOfPriService from "components/services/b2b2c/B2B2C_ValidatePricePrOfPriService";
import B2B2CRSOrganizationOrderCreateService from "components/services/b2b2c/B2B2C_RSOrganizationOrderCreateService";
import B2B2CRSOrganizationOrderModifyService from "components/services/b2b2c/B2B2C_RSOrganizationOrderModifyService";
import B2B2CRSOrganizationOrderTraceService from "components/services/b2b2c/B2B2C_RSOrganizationOrderTraceService";
import B2B2CConsultarTransaccionService from "components/services/b2b2c/B2B2CGatewayConsultarTransaccionService";
import B2B2CGatewayHistoricoPagosService from "components/services/b2b2c/B2B2CGatewayHistoricoPagosService";
import B2B2CGatewayTransaccionPagosService from "components/services/b2b2c/B2B2CGatewayTransaccionPagosService";
import B2B2CRSOrganizationPaymentRegisterService from "components/services/b2b2c/B2B2C_RSOrganizationPaymentRegisterService";
import B2B2CRSOrganizationBillingDebtPastDueService from "components/services/b2b2c/B2B2C_RSOrganizationBillingDebtPastDueService";
import B2B2CQuerryPendingBillsToPayGetPortfolioPseService from "components/services/b2b2c/B2B2CGatewayHistoricoPagosService";
import B2B2CConsultLogsAutomaticLogService from "components/services/b2b2c/B2B2C_ConsultLogsAutomaticLogService";
import B2B2CEXPWSUserInformationShopAGetUserInfoService from "components/services/b2b2c/B2B2C_EXPWSUserInformationShopAGetUserInfoService";
import B2B2CEXPWSTransferShopAUpdateOperationTransferService from "components/services/b2b2c/B2B2C_EXPWSTransferShopAUpdateOperationTransferService";
import B2B2CEXPWSTransferShopAGetComprobateStateTransferService from "components/services/b2b2c/B2B2C_EXPWSTransferShopAGetComprobateStateTransferService";

import SoapB2b2cValidationParamWebPCService from "components/services/b2b2c/SOAP_B2B2C_ValidationParamWebPCService";
import SoapB2b2cStartPaymentService from "components/services/b2b2c/SOAP_B2B2C_StartPaymentService";
import SoapB2b2cUpdatePaymentPSEService from "components/services/b2b2c/SOAP_B2B2C_UpdatePaymentPSEService";

import SoapB2b2cGenerarOTPTransaccionalCanalService from "components/services/b2b2c/SOAP_B2B2C_GenerarOTPTransaccionalCanalService";
import SoapB2b2cValidarOTPUsuarioService from "components/services/b2b2c/SOAP_B2B2C_ValidarOTPUsuarioService";

import SoapB2b2cGetSapCustomerIDService from "components/services/b2b2c/SOAP_B2B2C_GetSapCustomerIDService";
import SoapB2b2cGetSectorCentersService from "components/services/b2b2c/SOAP_B2B2C_GetSectorCentersService";
import SoapB2b2cGetRecipientsMerchandiseService from "components/services/b2b2c/SOAP_B2B2C_GetRecipientsMerchandiseService";
import SoapB2b2cGetCommercialPortalParametersService from "components/services/b2b2c/SOAP_B2B2C_GetCommercialPortalParametersService";

import SoapB2b2cGetAssociatedStoresService from "components/services/b2b2c/SOAP_B2B2C_GetAssociatedStoresService";
import SoapB2b2cGetInvoiceRecipientsService from "components/services/b2b2c/SOAP_B2B2C_GetInvoiceRecipientsService";
import SoapB2b2cGetDataRechargeStockService from "components/services/b2b2c/SOAP_B2B2C_GetDataRechargeStockService";
import SoapB2b2cGetApplicantsDataService from "components/services/b2b2c/SOAP_B2B2C_GetApplicantsDataService";

import SoapB2b2cTicketPendingService from "components/services/b2b2c/SOAP_B2B2C_TicketPendingService";
import SoapB2b2cDistributorBudgetPCService from "components/services/b2b2c/SOAP_B2B2C_DistributorBudgetPCService";
import SoapB2b2cCreditLimitPCService from "components/services/b2b2c/SOAP_B2B2C_CreditLimitPCService";
import SoapB2b2cExpiredPortfolioOrderPCService from "components/services/b2b2c/SOAP_B2B2C_ExpiredPortfolioOrderPCService";
import SoapB2b2cGetPortfolioPseService from "components/services/b2b2c/SOAP_B2B2C_GetPortfolioPseService";
import SoapB2b2cUpdateOperationTransferService from "components/services/b2b2c/SOAP_B2B2C_UpdateOperationTransferService";
import SoapB2b2cGetComprobateStateTransferService from "components/services/b2b2c/SOAP_B2B2C_GetComprobateStateTransferService";

import SoapB2b2cCreatePortalOrderService from "components/services/b2b2c/SOAP_B2B2C_CreatePortalOrderService";
import SoapB2b2cAutomaticLogService from "components/services/b2b2c/SOAP_B2B2C_AutomaticLogService";
import SoapB2b2cGetUserInfoService from "components/services/b2b2c/SOAP_B2B2C_GetUserInfoService";

import RSProMetrSKUTermB2B2CService from "components/services/RSProMetrSKUTermB2B2CService";
import ValidatePricePrOfPriService from "components/services/ValidatePricePrOfPriService";

/*************GOOGLE SERVICES*****************/
import RecaptchaV3Service from "components/services/RecaptchaV3Service";

const { REACT_APP_API } = process.env;

const ParameterCrud = () => {
	const [loading /* setLoading */] = useState(false);
	const [requestError, setRequestError] = useState(null);

	//Grupos de servicios
	const [service, setService] = useState(null);
	const [customerIdentityValidate, setCustomerIdentityValidate] = useState(false);
	const [customerIdentityExpedition, setCustomerIdentityExpedition] = useState(false);
	const [authenticaEntAdmincreateCustomer, setAuthenticaEntAdmincreateCustomer] = useState(false);

	//Servicios individuales
	const [offerValidate, setOfferValidate] = useState(false);
	const [skuSon, setSkuSon] = useState(false);
	const [orderSchedule, setOrderSchedule] = useState(false);
	const [tarjetasToken, setTarjetasToken] = useState(false);
	const [pagoTarjetasToken, setPagoTarjetasToken] = useState(false);
	const [order, setOrder] = useState(false);
	const [validateQuota, setValidateQuota] = useState(false);
	const [portability, setPortability] = useState(false);
	const [validateMinPrePost, setValidateMinPrePost] = useState(false);
	const [validateCheckTerms, setValidateCheckTerms] = useState(false);
	const [RSResourceOrderReserve, setRSResourceOrderReserve] = useState(false);
	const [customerAccount, setCustomerAccount] = useState(false); // MIGUEL
	const [validateReserve, setValidateReserve] = useState(false);
	const [capacity, setCapacity] = useState(false); //add Diego Tuesta - datuesta - 04/03/2024
	const [createOrder, setCreateOrder] = useState(false); //add Diego Tuesta - datuesta - 04/03/2024
	const [generatePin, setGeneratePin] = useState(false);
	const [validatePin, setValidatePin] = useState(false);
	const [generateOtp, setgenerateOtp] = useState(false);
	const [validateOtp, setvalidateOtp] = useState(false);
	const [validateForm, setValidateForm] = useState(false);
	const [ValidateFormasPago, setValidateFormasPago] = useState(false);
	const [minPrePos, setMinPrePos] = useState(false);
	const [consultFraudList, setConsultFraudList] = useState(false);
	const [pending, setPending] = useState(false);
	const [transunion, setTransunion] = useState(false);
	const [verifOpDon, setVerifOpDon] = useState(false);
	const [initialPayment, setInitialPayment] = useState(false);
	const [financialTerms, setFinancialTerms] = useState(false);
	const [validateEmailcustomer, setValidateEmailcustomer] = useState(false);
	const [validateDocumentCustomer, setValidateDocumentCustomer] = useState(false);
	const [normalization, setNormalization] = useState(false)
	const [customerPhone, setCustomerPhone] = useState(false)
	const [customerLogin, setCustomerLogin] = useState(false);
	const [recoveryPass, setrecoveryPass] = useState(false);
	const [changePass, setChangePass] = useState(false);
	const [getPaymentToken, setGetPaymentToken] = useState(false);
	const [postShoppingCart, setPostShoppingCart] = useState(false);
	const [generateToken, setGenerateToken] = useState(false);
	const [notifySales, setNotifySales] = useState(false);
	const [paramsGetMASofis, setParamsGetMASofis] = useState(false);
	const [paramsPatchMASofis, setParamsPatchMASofis] = useState(false);
	const [geographicAddress, setGeographicAddress] = useState(false);
	const [geographicAddressValidation, setGeographicAddressValidation] = useState(false);
	const [manageQuota, setManageQuota] = useState(false);
	const [msProMetrSKUTerminals, setMSProMetrSKUTerminals] = useState(false);
	const [authTokenEmail, setAuthTokenEmail] = useState(false);
	const [emailChannel, setEmailChannel] = useState(false);
	const [payment, setPayment] = useState(false);
	const [portabilidadNip, setPortabilidadNip] = useState(false);
	const [calculateDatesWindowChange, setCalculateDatesWindowChange] = useState(false);
	const [trackingOrder, setTrackingOrder] = useState(false);
	const [b2bOrderSchedule, setb2bOrderSchedule] = useState(false);
	const [b2bvalidateCheckTerms, setb2bvalidateCheckTerms] = useState(false);
	const [b2bconfirmPaymentB2B, setb2bconfirmPaymentB2B] = useState(false);
	const [groups, setGroups] = useState({});
	const [segmentB2B, setSegmentB2B] = useState(false);
	const [productPriceB2B, setProductPriceB2B] = useState(false);
	const [normalizationB2B, setNormalizationB2B] = useState(false);
	const [sendOrderB2B, setSendOrderB2B] = useState(false);
	const [consultFraudListB2B, setConsultFraudListB2B] = useState(false);
	const [authTokenB2B, setauthTokenB2B] = useState(false);
	const [validateUserB2B, setvalidateUserB2B] = useState(false);
	const [sendEmailB2B, setsendEmailB2B] = useState(false);
	const [skuChildB2B, setSkuChildB2B] = useState(false);
	const [getCitiesService, setGetCitiesService] = useState(false);
	const [getAdressTypesService, setGetAdressTypesService] = useState(false);
	const [getGroupingsService, setGetGroupingsService] = useState(false);
	const [getPropertyTypesService, setGetPropertyTypesService] = useState(false);
	const [orderReserverService, setOrderReserverService] = useState(false);
	const [getCitiesB2B, setGetCitiesB2B] = useState(false);
	const [getAddressTypesB2B, setGetAddressTypesB2B] = useState(false);
	const [getGroupingsB2B, setGetGroupingsB2B] = useState(false);
	const [getPropertyTypesB2B, setGetPropertyTypesB2B] = useState(false);
	const [selfcareLoginUsuarioB2B, setSelfcareLoginUsuarioB2B] = useState(false);
	const [selfcareRecuperarContraseñaUsuarioB2B, setSelfcareRecuperarContraseñaUsuarioB2B] = useState(false);
	const [selfcareCambiarContraseñaUsuarioB2B, setSelfcareCambiarContraseñaUsuarioB2B] = useState(false);
	const [selfcareModificarPerfilUsuarioB2B, setSelfcareModificarPerfilUsuarioB2B] = useState(false);
	const [selfcareConsultarPerfilUsuarioB2B, setSelfcareConsultarPerfilUsuarioB2B] = useState(false);
	const [selfcareSolicitarTokenAutenticacionSSOB2B, setSelfcareSolicitarTokenAutenticacionSSOB2B] = useState(false);
	const [wareHouses, setWareHouses] = useState(false);
	const [portabilityList, setPortabilityList] = useState(false);
	const [recaptchaV3, setRecaptchaV3] = useState(false);
	const [checkNipStatus, setCheckNipStatus] = useState(false);
	const [idClaroVerify, setIdClaroVerify] = useState(false);
	const [rsProOrdeProdOrderecommerce, setRSProOrdeProdOrderecommerce] = useState(false);
	const [rsPartyBillRecvMgTT, setRSPartyBillRecvMgTT] = useState(false);
	const [rSParBillRecvMgServ, setRSParBillRecvMgServ] = useState(false);
	const [customerRiskProfile, setCustomerRiskProfile] = useState(false);
	const [validatePortabilityPP, setValidatePortabilityPP] = useState(false);
	const [getBillCyclesService, setGetBillCyclesService] = useState(false);
	const [createAccountManagement, setCreateAccountManagementB2C] = useState(false);
	const [portabilityIn, setPortabilityIn] = useState(false);
	const [requestNIP, setRequestNIP] = useState(false);
	const [getSimulation, setGetSimulation] = useState(false);
	const [productListPromise, setProductListPromise] = useState(false);
	const [saveNip, setSaveNip] = useState(false);
	const [statusNip, setStatusNip] = useState(false);
	const [openIdConnectToken, setOpenIdConnectToken] = useState(false);
	const [tokenOauthTwoV1, setTokenOauthTwoV1] = useState(false);
	const [requestsFilters, setRequestsFilters] = useState(false);
	const [msCusAccoInfoEcom, setMSCusAccoInfoEcom] = useState(false);
	const [consultEventsStatus, setConsultEventsStatus] = useState(false);
	const [rsBusInteQryCondbyCred, setRSBusInteQryCondbyCred] = useState(false);
	const [rsBusInteAskSurCr, setRSBusInteAskSurCr] = useState(false);


	/*************************
	 * B2B2C
	**************************/

	const [b2b2cMsSecurityEntityAuthUser, setB2b2cMsSecurityEntityAuthUser] = useState(false);
	const [b2b2cOrganizationProfileAgent, setB2b2cOrganizationProfileAgent] = useState(false);
	const [b2b2cOrganizationProfileCreditLimit, setB2b2cOrganizationProfileCreditLimit] = useState(false);
	const [b2b2cValidatePricePrOfPri, setB2b2cValidatePricePrOfPri] = useState(false);
	const [b2b2cCRSOrganizationOrderCreate, setB2b2cCRSOrganizationOrderCreate] = useState(false);
	const [b2b2cRSOrganizationOrderModify, setB2b2cRSOrganizationOrderModify] = useState(false);
	const [b2b2cRSOrganizationOrderTrace, setB2b2cRSOrganizationOrderTrace] = useState(false);
	const [b2b2cConsultarTransaccion, setB2b2cConsultarTransaccion] = useState(false);
	const [b2b2cGatewayHistoricoPagos, setB2b2cGatewayHistoricoPagos] = useState(false);
	const [b2b2cGatewayTransaccionPagos, setB2b2cGatewayTransaccionPagos] = useState(false);
	const [b2b2cRSOrganizationPaymentRegister, setB2b2cRSOrganizationPaymentRegister] = useState(false);
	const [b2b2cRSOrganizationBillingDebtPastDue, setB2b2cRSOrganizationBillingDebtPastDue] = useState(false);
	const [b2b2cQuerryPendingBillsToPayGetPortfolioPse, setB2b2cQuerryPendingBillsToPayGetPortfolioPse] = useState(false);
	const [b2b2cConsultLogsAutomaticLog, setB2b2cConsultLogsAutomaticLog] = useState(false);
	const [b2b2cEXPWSUserInformationShopAGetUserInfo, setB2b2cEXPWSUserInformationShopAGetUserInfo] = useState(false);
	const [b2b2cEXPWSTransferShopAUpdateOperationTransfer, setB2b2cEXPWSTransferShopAUpdateOperationTransfer] = useState(false);
	const [b2b2cEXPWSTransferShopAGetComprobateStateTransfer, setB2b2cEXPWSTransferShopAGetComprobateStateTransfer] = useState(false);

	const [soapB2b2cValidationParamWebPC, setSoapB2b2cValidationParamWebPC] = useState(false);
	const [soapB2b2cStartPayment, setSoapB2b2cStartPayment] = useState(false);
	const [soapB2b2cUpdatePaymentPSE, setSoapB2b2cUpdatePaymentPSE] = useState(false);
	const [soapB2b2cGenerarOTPTransaccionalCanal, setsoapB2b2cGenerarOTPTransaccionalCanal] = useState(false);
	const [soapB2b2cValidarOTPUsuario, setSoapB2b2cValidarOTPUsuario] = useState(false);

	const [soapB2b2cGetSapCustomerID, setSoapB2b2cGetSapCustomerID] = useState(false);
	const [soapB2b2cGetSectorCenters, setSoapB2b2cGetSectorCenters] = useState(false);
	const [soapB2b2cGetRecipientsMerchandise, setSoapB2b2cGetRecipientsMerchandise] = useState(false);
	const [soapB2b2cGetCommercialPortalParameters, setSoapB2b2cGetCommercialPortalParameters] = useState(false);

	const [soapB2b2cGetAssociatedStores, setSoapB2b2cGetAssociatedStores] = useState(false);
	const [soapB2b2cGetInvoiceRecipients, setSoapB2b2cGetInvoiceRecipients] = useState(false);
	const [soapB2b2cGetDataRechargeStock, setSoapB2b2cGetDataRechargeStock] = useState(false);
	const [soapB2b2cGetApplicantsData, setSoapB2b2cGetApplicantsData] = useState(false);

	const [soapB2b2cTicketPending, setSoapB2b2cTicketPending] = useState(false);
	const [soapB2b2cDistributorBudgetPC, setSoapB2b2cDistributorBudgetPC] = useState(false);
	const [soapB2b2cCreditLimitPC, setSoapB2b2cCreditLimitPC] = useState(false);
	const [soapB2b2cExpiredPortfolioOrderPC, setSoapB2b2cExpiredPortfolioOrderPC] = useState(false);
	const [soapB2b2cGetPortfolioPse, setSoapB2b2cGetPortfolioPse] = useState(false);
	const [soapB2b2cGetComprobateStateTransfer, setSoapB2b2cGetComprobateStateTransfer] = useState(false);
	const [soapB2b2cUpdateOperationTransfer, setSoapB2b2cUpdateOperationTransfer] = useState(false);

	const [soapB2b2cCreatePortalOrder, setSoapB2b2cCreatePortalOrder] = useState(false);
	const [soapB2b2cAutomaticLog, setSoapB2b2cAutomaticLog] = useState(false);
	const [soapB2b2cGetUserInfo, setSoapB2b2cGetUserInfo] = useState(false);
	const [rsProMetrSKUTermB2B2C, setRSProMetrSKUTermB2B2C] = useState(false);
	const [validatePricePrOfPri, setValidatePricePrOfPri] = useState(false);

	let api = HelpHttp();

	// const urlTrama = `${REACT_APP_API}/parameters/findTrama`;
	const urlServices = `${REACT_APP_API}/services/findByAbilities`;

	async function showParametersByService(key, service) {
		//!Aqui se hace el cambio de servicio
		setService(service);
		[...document.getElementsByClassName("lg-btn-services")].forEach((e) =>
			e.classList.remove("active")
		);
		document.getElementById(`lg-btn-${key}-${service.code}`).classList.add("active");

		console.log("Service => ", service);

		setValidateReserve(false);
		setCapacity(false);
		setCreateOrder(false);
		setGeneratePin(false);
		setValidatePin(false);
		setgenerateOtp(false);
		setvalidateOtp(false);
		setValidateForm(false);
		setOrderSchedule(false);
		setTarjetasToken(false);
		setPagoTarjetasToken(false);
		setOfferValidate(false);
		setSkuSon(false);
		setOrder(false);
		setValidateQuota(false);
		setPortability(false);
		setValidateMinPrePost(false);
		setValidateCheckTerms(false);
		setRSResourceOrderReserve(false);
		setCustomerAccount(false);
		setValidateFormasPago(false);
		setMinPrePos(false);
		setConsultFraudList(false);
		setTransunion(false);
		setVerifOpDon(false);
		setCustomerIdentityValidate(false);
		setCustomerIdentityExpedition(false);
		setAuthenticaEntAdmincreateCustomer(false);
		setInitialPayment(false);
		setFinancialTerms(false);
		setValidateEmailcustomer(false);
		setValidateDocumentCustomer(false);
		setNormalization(false)
		setCustomerLogin(false);
		setrecoveryPass(false);
		setChangePass(false);
		setGetPaymentToken(false);
		setPostShoppingCart(false);
		setCustomerPhone(false);
		setGenerateToken(false);
		setNotifySales(false);
		setParamsGetMASofis(false);
		setParamsPatchMASofis(false);
		setGeographicAddress(false);
		setGeographicAddressValidation(false);
		setManageQuota(false);
		setMSProMetrSKUTerminals(false);
		setAuthTokenEmail(false);
		setEmailChannel(false);
		setPayment(false);
		setPortabilidadNip(false);
		setCalculateDatesWindowChange(false);
		setTrackingOrder(false);
		setb2bOrderSchedule(false);
		setb2bvalidateCheckTerms(false);
		setb2bconfirmPaymentB2B(false);
		setSegmentB2B(false);
		setProductPriceB2B(false);
		setNormalizationB2B(false);
		setSendOrderB2B(false);
		setConsultFraudListB2B(false);
		setauthTokenB2B(false);
		setvalidateUserB2B(false);
		setsendEmailB2B(false);
		setSkuChildB2B(false);
		setGetCitiesService(false);
		setGetAdressTypesService(false);
		setGetGroupingsService(false);
		setGetPropertyTypesService(false);
		setOrderReserverService(false);
		setGetCitiesB2B(false);
		setGetAddressTypesB2B(false);
		setGetGroupingsB2B(false);
		setGetPropertyTypesB2B(false);
		setSelfcareLoginUsuarioB2B(false);
		setSelfcareRecuperarContraseñaUsuarioB2B(false);
		setSelfcareCambiarContraseñaUsuarioB2B(false);
		setSelfcareModificarPerfilUsuarioB2B(false);
		setSelfcareConsultarPerfilUsuarioB2B(false);
		setSelfcareSolicitarTokenAutenticacionSSOB2B(false);
		setWareHouses(false);
		setPortabilityList(false);
		setRecaptchaV3(false);
		setCheckNipStatus(false);
		setIdClaroVerify(false);
		setRSProOrdeProdOrderecommerce(false);
		setRSPartyBillRecvMgTT(false);
		setRSParBillRecvMgServ(false);
		setCustomerRiskProfile(false);
		setValidatePortabilityPP(false);
		setGetBillCyclesService(false);
		setCreateAccountManagementB2C(false);
		setPortabilityIn(false);
		setRequestNIP(false);
		setGetSimulation(false);
		setProductListPromise(false);
		setSaveNip(false);
		setStatusNip(false);
		setOpenIdConnectToken(false);
		setTokenOauthTwoV1(false);
		setRequestsFilters(false);
		setMSCusAccoInfoEcom(false);
		setConsultEventsStatus(false);
		setRSBusInteQryCondbyCred(false);
		setRSBusInteAskSurCr(false);

		// B2B2C
		setB2b2cMsSecurityEntityAuthUser(false);
		setB2b2cOrganizationProfileAgent(false);
		setB2b2cOrganizationProfileCreditLimit(false);
		setB2b2cValidatePricePrOfPri(false);
		setB2b2cCRSOrganizationOrderCreate(false);
		setB2b2cRSOrganizationOrderModify(false);
		setB2b2cRSOrganizationOrderTrace(false);
		setB2b2cConsultarTransaccion(false);
		setB2b2cGatewayHistoricoPagos(false);
		setB2b2cGatewayTransaccionPagos(false);
		setB2b2cRSOrganizationPaymentRegister(false);
		setB2b2cRSOrganizationBillingDebtPastDue(false);
		setB2b2cQuerryPendingBillsToPayGetPortfolioPse(false);
		setB2b2cConsultLogsAutomaticLog(false);
		setB2b2cEXPWSUserInformationShopAGetUserInfo(false);
		setB2b2cEXPWSTransferShopAUpdateOperationTransfer(false);
		setB2b2cEXPWSTransferShopAGetComprobateStateTransfer(false);
		setSoapB2b2cValidationParamWebPC(false);
		setSoapB2b2cStartPayment(false);
		setSoapB2b2cUpdatePaymentPSE(false);
		setsoapB2b2cGenerarOTPTransaccionalCanal(false);
		setSoapB2b2cValidarOTPUsuario(false);
		setSoapB2b2cGetSapCustomerID(false);
		setSoapB2b2cGetSectorCenters(false);
		setSoapB2b2cGetRecipientsMerchandise(false);
		setSoapB2b2cGetCommercialPortalParameters(false);
		setSoapB2b2cGetAssociatedStores(false);
		setSoapB2b2cGetInvoiceRecipients(false);
		setSoapB2b2cGetDataRechargeStock(false);
		setSoapB2b2cGetApplicantsData(false);
		setSoapB2b2cTicketPending(false);
		setSoapB2b2cDistributorBudgetPC(false);
		setSoapB2b2cCreditLimitPC(false);
		setSoapB2b2cExpiredPortfolioOrderPC(false);
		setSoapB2b2cGetPortfolioPse(false);
		setSoapB2b2cGetComprobateStateTransfer(false);
		setSoapB2b2cUpdateOperationTransfer(false);
		setSoapB2b2cCreatePortalOrder(false);
		setSoapB2b2cAutomaticLog(false);
		setSoapB2b2cGetUserInfo(false);
		setRSProMetrSKUTermB2B2C(false);
		setValidatePricePrOfPri(false);

		console.log("service.code: ", service.code);

		switch (service.code) {
			case "orderSchedule":
				setOrderSchedule(true);
				break;
			case "tarjetasToken":
				setTarjetasToken(true);
				break;
			case "pagoTarjetasToken":
				setPagoTarjetasToken(true);
				break;
			case "RSProductOfferValidate":
				setOfferValidate(true);
				break;
			case "getSkuSonGuest":
				setSkuSon(true);
				break;
			case "order":
				setOrder(true);
				break;
			case "validateQuota":
				setValidateQuota(true);
				break;
			case "validateMinPrePost":
				setValidateMinPrePost(true);
				break;
			case "validateCheckTerms":
				setValidateCheckTerms(true);
				break;
			case "validatePortability":
				setPortability(true);
				break;
			case "RSResourceOrderReserve":
				setRSResourceOrderReserve(true);
				break;
			case "CustomerAccount":
				setCustomerAccount(true);
				break;
			case "ValidateReserve":
				setValidateReserve(true);
				break;
			case "capacity":
				setCapacity(true);
				break;
			case "createOrder":
				setCreateOrder(true);
				break;
			case "generatePin":
				setGeneratePin(true);
				break;
			case "validatePin":
				setValidatePin(true);
				break;
			case "generateOtp":
				setgenerateOtp(true);
				break;
			case "validateOtp":
				setvalidateOtp(true);
				break;
			case "validateForm":
				setValidateForm(true);
				break;
			case "validateFormasPago":
				setValidateFormasPago(true);
				break;
			case "MinPrePos":
				setMinPrePos(true);
				break;
			case "ConsultFraudList":
				setConsultFraudList(true);
				break;
			case "RSCustomerIdentity_Validate":
				setCustomerIdentityValidate(true);
				break;
			case "RSCustomerIdentity_ExpeditionDateDocument":
				setCustomerIdentityExpedition(true);
				break;
			case "RSAuthenticaEntAdmin_Create":
				setAuthenticaEntAdmincreateCustomer(true);
				break;
			case "transunion":
				setTransunion(true);
				break;
			case "verifOpDon":
				setVerifOpDon(true);
				break;
			case "initialPayment":
				setInitialPayment(true);
				break;
			case "financialTerms":
				setFinancialTerms(true);
				break;
			case "validateEmailcustomer":
				setValidateEmailcustomer(true);
				break;
			case "validateDocumentCustomer":
				setValidateDocumentCustomer(true);
				break;
			case "Normalization":
				setNormalization(true);
				break;
			case "customerLogin":
				setCustomerLogin(true);
				break;
			case "recoveryPass":
				setrecoveryPass(true);
				break;
			case "changePass":
				setChangePass(true);
				break;
			case "getPaymentToken":
				setGetPaymentToken(true);
				break;
			case "postShoppingCart":
				setPostShoppingCart(true);
				break;
			case "customerPhone":
				setCustomerPhone(true);
				break;
			case "generateToken":
				setGenerateToken(true);
				break;
			case "notifySales":
				setNotifySales(true);
				break;
			case "ParametersGetMA":
				setParamsGetMASofis(true);
				break;
			case "ParametersPatchMA":
				setParamsPatchMASofis(true);
				break;
			case "geographicAddress":
				setGeographicAddress(true);
				break;
			case "geographicAddressValidation":
				setGeographicAddressValidation(true);
				break;
			case "manageQuota":
				setManageQuota(true);
				break;
			case "msProMetrSKUTerminals":
				setMSProMetrSKUTerminals(true);
				break;
			case "authTokenNotification":
				setAuthTokenEmail(true);
				break;
			case "notificationCustomerChannel":
				setEmailChannel(true);
				break;
			case "payments":
				setPayment(true);
				break;
			case "portabilidadNip":
				setPortabilidadNip(true);
				break;
			case "calculateDatesWindowChange":
				setCalculateDatesWindowChange(true);
				break;
			case "TrackingOrder":
				setTrackingOrder(true);
				break;
			case "B2BOrderSchedule":
				setb2bOrderSchedule(true);
				break;
			case "validateCheckTermsB2B":
				setb2bvalidateCheckTerms(true);
				break;
			case "confirmPaymentB2B":
				setb2bconfirmPaymentB2B(true);
				break;
			case "SegmentB2B":
				setSegmentB2B(true);
				break;
			case "ProductPriceB2B":
				setProductPriceB2B(true);
				break;
			case "NormalizationB2B":
				setNormalizationB2B(true);
				break;
			case "sendOrderB2B":
				setSendOrderB2B(true);
				break;
			case "consultFraudListB2B":
				setConsultFraudListB2B(true);
				break;
			case "authTokenB2B":
				setauthTokenB2B(true);
				break;
			case "validateUserB2B":
				setvalidateUserB2B(true);
				break;
			case "sendEmailB2B":
				setsendEmailB2B(true);
				break;
			case "skuChildB2B":
				setSkuChildB2B(true);
				break;
			case "getCities":
				setGetCitiesService(true);
				break;
			case "getAdressTypes":
				setGetAdressTypesService(true);
				break;
			case "getGroupings":
				setGetGroupingsService(true);
				break;
			case "getPropertyTypes":
				setGetPropertyTypesService(true);
				break;
			case "orderReserver":
				setOrderReserverService(true);
				break;
			case "getCitiesB2B":
				setGetCitiesB2B(true);
				break;
			case "getAddressTypesB2B":
				setGetAddressTypesB2B(true);
				break;
			case "getGroupingsB2B":
				setGetGroupingsB2B(true);
				break;
			case "getPropertyTypesB2B":
				setGetPropertyTypesB2B(true);
				break;
			case "selfcareLoginUsuarioB2B":
				setSelfcareLoginUsuarioB2B(true);
				break;
			case "selfcareRecuperarContraseñaUsuarioB2B":
				setSelfcareRecuperarContraseñaUsuarioB2B(true);
				break;
			case "selfcareCambiarContraseñaUsuarioB2B":
				setSelfcareCambiarContraseñaUsuarioB2B(true);
				break;
			case "selfcareModificarPerfilUsuarioB2B":
				setSelfcareModificarPerfilUsuarioB2B(true);
				break;
			case "selfcareConsultarPerfilUsuarioB2B":
				setSelfcareConsultarPerfilUsuarioB2B(true);
				break;
			case "selfcareSolicitarTokenAutenticacionSSOB2B":
				setSelfcareSolicitarTokenAutenticacionSSOB2B(true);
				break;
			case "warehouses":
				setWareHouses(true);
				break;
			case "portabilityList":
				setPortabilityList(true);
				break;
			case "recaptcha_v3":
				setRecaptchaV3(true);
				break;
			case "checkNipStatus":
				setCheckNipStatus(true);
				break;
			case "idclaro_verify":
				setIdClaroVerify(true);
				break;
			case "rsProOrderEcommerce":
				setRSProOrdeProdOrderecommerce(true);
				break;
			case "rsPartyBillRecvMgTT":
				setRSPartyBillRecvMgTT(true);
				break;
			case "RSParBillRecvMgServ":
				setRSParBillRecvMgServ(true);
				break;
			case "customerRiskProfile":
				setCustomerRiskProfile(true);
				break;
			case "validatePortabilityPP":
				setValidatePortabilityPP(true);
				break;
			case "B2C_SF_PortabilityIn":
				setPortabilityIn(true);
				break;
			case "B2C_SF_RequestNIP":
				setRequestNIP(true);
				break;
			case "B2C_SF_getSimulation":
				setGetSimulation(true);
				break;
			case "B2C_SF_ProductListPromise":
				setProductListPromise(true);
				break;
			case "B2C_SF_RequestsFilters":
				setRequestsFilters(true);
				break;
			case "GetBillServ":
				setGetBillCyclesService(true);
				break;
			case "createAccountManagementB2C":
				setCreateAccountManagementB2C(true);
				break;
			case "saveNip":
				setSaveNip(true);
				break;
			case "statusNip":
				setStatusNip(true);
				break;
			case "tokenOAuthTwoV1":
				setTokenOauthTwoV1(true);
				break;
			case "openIdConnectToken":
				setOpenIdConnectToken(true);
				break;
			case "msCusAccoInfoEcom":
				setMSCusAccoInfoEcom(true);
				break;
			case "cusConsultEvents":
				setConsultEventsStatus(true);
				break;
			case "rsBusInteQryCondbyCred": 
				setRSBusInteQryCondbyCred(true);
				break;
			case "rsBusInteAskSurCr":
				setRSBusInteAskSurCr(true);
				break;
			case "B2B2C_Authenticate":
				setB2b2cMsSecurityEntityAuthUser(true);
				break;
			case "B2B2C_OrganizationProfile_agent":
				setB2b2cOrganizationProfileAgent(true);
				break;
			case "B2B2C_OrganizationProfile_creditLimit":
				setB2b2cOrganizationProfileCreditLimit(true);
				break;
			case "B2B2C_ValidatePricePrOfPri":
				setB2b2cValidatePricePrOfPri(true);
				break;
			case "B2B2C_RSOrganizationOrder_create":
				setB2b2cCRSOrganizationOrderCreate(true);
				break;
			case "B2B2C_RSOrganizationOrder_modify":
				setB2b2cRSOrganizationOrderModify(true);
				break;
			case "B2B2C_RSOrganizationOrder_trace":
				setB2b2cRSOrganizationOrderTrace(true);
				break;
			case "B2B2C_consultarTransaccionRequest":
				setB2b2cConsultarTransaccion(true);
				break;
			case "B2B2C_B2B2CGateway_historicoPagos":
				setB2b2cGatewayHistoricoPagos(true);
				break;
			case "B2B2C_B2B2CGateway_TransaccionPagos":
				setB2b2cGatewayTransaccionPagos(true);
				break;
			case "B2B2C_RSOrganizationPayment_Register":
				setB2b2cRSOrganizationPaymentRegister(true);
				break;
			case "B2B2C_RSOrganizationBilling_debtPastDue":
				setB2b2cRSOrganizationBillingDebtPastDue(true);
				break;
			case "B2B2C_QuerryPendingBillsToPay_GetPortfolioPse":
				setB2b2cQuerryPendingBillsToPayGetPortfolioPse(true);
				break;
			case "B2B2C_ConsultLogs_AutomaticLog":
				setB2b2cConsultLogsAutomaticLog(true);
				break;
			case "B2B2C_EXP_WSUserInformationShopA_GetUserInfo":
				setB2b2cEXPWSUserInformationShopAGetUserInfo(true);
				break;
			case "B2B2C_EXP_WSTransferShopA_UpdateOperationTransfer":
				setB2b2cEXPWSTransferShopAUpdateOperationTransfer(true);
				break;
			case "B2B2C_WSTransferShopA_GetComprobateStateTransfer":
				setB2b2cEXPWSTransferShopAGetComprobateStateTransfer(true);
				break;


			case "B2B2C_ValidationParamWebPC":
				setSoapB2b2cValidationParamWebPC(true);
				break;
			case "B2B2C_StartPayment":
				setSoapB2b2cStartPayment(true);
				break;
			case "B2B2C_UpdatePaymentPSE":
				setSoapB2b2cUpdatePaymentPSE(true);
				break;
			case "B2B2C_generarOTPTransaccionalCanal":
				setsoapB2b2cGenerarOTPTransaccionalCanal(true);
				break;
			case "B2B2C_validarOTPUsuario":
				setSoapB2b2cValidarOTPUsuario(true);
				break;

			case "B2B2C_GetSapCustomerID":
				setSoapB2b2cGetSapCustomerID(true);
				break;
			case "B2B2C_GetSectorCenters":
				setSoapB2b2cGetSectorCenters(true);
				break;
			case "B2B2C_GetRecipientsMerchandise":
				setSoapB2b2cGetRecipientsMerchandise(true);
				break;
			case "B2B2C_GetCommercialPortalParameters":
				setSoapB2b2cGetCommercialPortalParameters(true);
				break;
			case "B2B2C_GetAssociatedStores":
				setSoapB2b2cGetAssociatedStores(true);
				break;
			case "B2B2C_GetInvoiceRecipients":
				setSoapB2b2cGetInvoiceRecipients(true);
				break;
			case "B2B2C_GetDataRechargeStock":
				setSoapB2b2cGetDataRechargeStock(true);
				break;
			case "B2B2C_GetApplicantsData":
				setSoapB2b2cGetApplicantsData(true);
				break;

			case "B2B2C_TicketPending":
				setSoapB2b2cTicketPending(true);
				break;
			case "B2B2C_DistributorBudgetPC":
				setSoapB2b2cDistributorBudgetPC(true);
				break;
			case "B2B2C_CreditLimitPC":
				setSoapB2b2cCreditLimitPC(true);
				break;
			case "B2B2C_ExpiredPortfolioOrderPC":
				setSoapB2b2cExpiredPortfolioOrderPC(true);
				break;
			case "B2B2C_GetPortfolioPse":
				setSoapB2b2cGetPortfolioPse(true);
				break;
			case "B2B2C_GetComprobateStateTransfer":
				setSoapB2b2cGetComprobateStateTransfer(true);
				break;
			case "B2B2C_UpdateOperationTransfer":
				setSoapB2b2cUpdateOperationTransfer(true);
				break;
			case "B2B2C_CreatePortalOrder":
				setSoapB2b2cCreatePortalOrder(true);
				break;
			case "B2B2C_AutomaticLog":
				setSoapB2b2cAutomaticLog(true);
				break;
			case "B2B2C_GetUserInfo":
				setSoapB2b2cGetUserInfo(true);
				break;
			case "rsProMetrSKUTermB2B2C":
				setRSProMetrSKUTermB2B2C(true);
				break;
			case "validatePricePrOfPri":
				setValidatePricePrOfPri(true);
				break;
			default:
				setPending(true);
				break;
		}

		console.log("pagoTarjetasToken: ", pagoTarjetasToken);
		console.log("pending: ", pending);
		window.scrollTo(0, 0);
	}

	useEffect(() => {
		const getServices = () => {
			//setLoading(true);
			trackPromise(
				api.get(urlServices).then((res) => {
					if (res.err) {
						//setServices(null);
						setRequestError(res);
					} else {

						const grouped = res.reduce((acc, service) => {


							if (service.groupCodes.length > 0) {
								(service.groupCodes).forEach(group => {
									if (!acc[group]) acc[group] = [];
									acc[group].push(service);
								});
							} else {
								if (!acc["NO_AGRUPADO"]) acc["NO_AGRUPADO"] = [];
								acc["NO_AGRUPADO"].push(service);
							}
							return acc;
						}, {});
						setGroups(grouped);


					}
				})
			);
		};
		getServices(urlServices);
		// eslint-disable-next-line
	}, []);
	return (
		<div className="container" style={{ minHeight: "100vh" }}>
			<div className="row no-gutters my-md-4">
				<p>
					<small>
						Elija el servicio en el listado para visualizar sus parámetros y
						editarlos
					</small>
				</p>
				<div className="col-md-3 col-xs-12 ">
					<div className="list-group">
						{loading && <SpinnerBootrap />}
						{requestError && <RequestError msg={requestError} />}

						{groups && Object.keys(groups).map((key) => {
							const services = groups[key];
							return (
								<Accordion key={key} defaultActiveKey="0">
									<Accordion.Item eventKey="1">
										<Accordion.Header>{key}</Accordion.Header>
										<Accordion.Body>
											{services.map(ser => (
												<button
													id={`lg-btn-${key}-${ser.code}`}
													key={ser.code}
													type="button"
													onClick={() => showParametersByService(key, ser)}
													className="lg-btn-services list-group-item list-group-item-action"
												>
													{ser.name}
												</button>
											))}
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							);
						})}
					</div>
				</div>
				<div className="col-md-9 col-xs-12 ">
					{b2bconfirmPaymentB2B && <PaymentServiceB2B service={service} />}
					{b2bvalidateCheckTerms && <CheckTermsService service={service} />}
					{b2bOrderSchedule && <OrderScheduleServiceB2B service={service} />}
					{orderSchedule && <OrderScheduleService service={service} />}
					{order && <Order service={service}></Order>}
					{validateQuota && <ValidateQuotaService service={service}></ValidateQuotaService>}
					{customerAccount && (
						<CustomerAccountService service={service}></CustomerAccountService>
					)}
					{portability && (
						<PortabilityService service={service}></PortabilityService>
					)}
					{validateMinPrePost && (
						<MinPrePostService service={service}></MinPrePostService>
					)}
					{validateCheckTerms && (
						<CheckTermsService service={service}></CheckTermsService>
					)}
					{RSResourceOrderReserve && (
						<RSResourceOrderReserveService service={service} />
					)}
					{validateReserve && <ValidateReserve service={service} />}
					{paramsPatchMASofis && <ParamsPatchMASofisService service={service} />}
					{paramsGetMASofis && <ParamsGetMASofisService service={service} />}
					{initialPayment && <InitialPaymentService service={service} />}
					{financialTerms && <FinancialTermsService service={service} />}
					{geographicAddress && <GeographicAddressService service={service} />}
					{geographicAddressValidation && <GeographicAddressValidationService service={service} />}
					{validateEmailcustomer && <ValidateEmailcustomerService service={service} />}
					{validateDocumentCustomer && <ValidateDocumentCustomerService service={service} />}
					{normalization && <NormalizationService service={service} />}
					{customerPhone && <CustomerPhoneService service={service} />}
					{customerLogin && <CustomerLoginServer service={service} />}
					{recoveryPass && <RecoveryPassServer service={service} />}
					{changePass && <ChangePassServer service={service} />}
					{authenticaEntAdmincreateCustomer && <AuthenticaEntAdminCreateCustomerService service={service} />}
					{getPaymentToken && <GetPaymentTokenService service={service} />}
					{postShoppingCart && <PostShoppingCartService service={service} />}
					{generateToken && <GenerateTokenService service={service} />}
					{notifySales && <NotifySalesService service={service} />}
					{msProMetrSKUTerminals && <MSProMetrSKUTerminalsService service={service} />}
					{authTokenEmail && <AuthTokenNotificationService service={service} />}
					{emailChannel && <NotificationCustomerChannelService service={service} />}
					{payment && <PaymentService service={service} />}
					{sendOrderB2B && <SendOrderB2BService service={service} />}
					{consultFraudListB2B && <ConsultFraudListB2BService service={service} />}
					{authTokenB2B && <AuthTokenB2BService service={service} />}
					{validateUserB2B && <ValidateUserB2BService service={service} />}
					{sendEmailB2B && <SendEmailB2BService service={service} />}
					{skuChildB2B && <SkuChildB2BService service={service} />}
					{getCitiesService && <GetCitiesService service={service} />}
					{getAdressTypesService && <GetAdressTypesService service={service} />}
					{getGroupingsService && <GetGroupingsService service={service} />}
					{getPropertyTypesService && <GetPropertyTypesService service={service} />}
					{orderReserverService && <OrderReserverService service={service} />}
					{recaptchaV3 && <RecaptchaV3Service service={service} />}

					{generatePin && (
						<GeneratePinService service={service}></GeneratePinService>
					)}
					{validatePin && (
						<ValidatePinService service={service}></ValidatePinService>
					)}
					{generateOtp && (
						<GenerateOtpService service={service}></GenerateOtpService>
					)}
					{validateOtp && (
						<ValidateOtpService service={service}></ValidateOtpService>
					)}
					{validateForm && (
						<ValidateFormService service={service}></ValidateFormService>
					)}
					{ValidateFormasPago && (
						<FormasPagoService service={service}></FormasPagoService>
					)}
					{transunion && <Transunion service={service}></Transunion>}
					{tarjetasToken && <TarjetasTokenService service={service}></TarjetasTokenService>}
					{pagoTarjetasToken && <PagoTarjetasTokenService service={service}></PagoTarjetasTokenService>}
					{capacity && <CapacityHService service={service} />}
					{createOrder && <CreateOrderHService service={service} />}
					{minPrePos && <MinPrePosService service={service}></MinPrePosService>}
					{consultFraudList && (
						<ConsultFraudListService
							service={service}
						></ConsultFraudListService>
					)}
					{customerIdentityValidate && (
						<CustomerIdentityValidateService
							service={service}
						></CustomerIdentityValidateService>
					)}
					{customerIdentityExpedition && (
						<CustomerIdentityExpeditionService
							service={service}
						></CustomerIdentityExpeditionService>
					)}

					{verifOpDon && <VerifOpDonSevice service={service}></VerifOpDonSevice>}
					{offerValidate && <OfferValidate service={service}></OfferValidate>}
					{skuSon && <SkuSonGuest service={service}></SkuSonGuest>}
					{manageQuota && <ManageQuotaService service={service} />}
					{portabilidadNip && <PortabilidadNip service={service} />}
					{calculateDatesWindowChange && <CalculateDatesWindowChange service={service} />}
					{trackingOrder && <TrackingOrderService service={service} ></TrackingOrderService>}
					{segmentB2B && (<SegmentService service={service} ></SegmentService>)}
					{productPriceB2B && (<ProductPriceService service={service} ></ProductPriceService>)}
					{normalizationB2B && (<Normalizationb2BService service={service} ></Normalizationb2BService>)}
					{getCitiesB2B && (<GetCitiesB2BService service={service} ></GetCitiesB2BService>)}
					{getAddressTypesB2B && (<GetAddressTypesB2BService service={service} ></GetAddressTypesB2BService>)}
					{getGroupingsB2B && (<GetGroupingsB2BService service={service} ></GetGroupingsB2BService>)}
					{getPropertyTypesB2B && (<GetPropertyTypesB2BService service={service} ></GetPropertyTypesB2BService>)}
					{selfcareLoginUsuarioB2B && (<SelfCareManagementLoginUsuarioB2BService service={service} ></SelfCareManagementLoginUsuarioB2BService>)}
					{selfcareRecuperarContraseñaUsuarioB2B && (<SelfCareManagementRecuperarContraseñaUsuarioB2BService service={service} />)}
					{selfcareCambiarContraseñaUsuarioB2B && (<SelfCareManagementCambiarContraseñaUsuarioB2BService service={service} />)}
					{selfcareModificarPerfilUsuarioB2B && (<SelfCareManagementModificarPerfilUsuarioB2BService service={service} />)}
					{selfcareConsultarPerfilUsuarioB2B && (<SelfCareManagementConsultarPerfilUsuarioB2BService service={service} />)}
					{selfcareSolicitarTokenAutenticacionSSOB2B && (<SelfCareManagementSolicitarTokenAutenticacionSSOB2BService service={service} />)}
					{wareHouses && (<WareHouses service={service} />)}
					{portabilityList && (<PortabilityListService service={service} />)}
					{checkNipStatus && (<CheckNipStatusService service={service} />)}
					{idClaroVerify && (<IdClaroVerifyService service={service} />)}
					{rsProOrdeProdOrderecommerce && (<RSProOrdeProdOrderecommerceService service={service} />)}
					{rsPartyBillRecvMgTT && (<RSPartyBillRecvMgTTService service={service} />)}
					{rSParBillRecvMgServ && (<RSParBillRecvMgServService service={service} />)}
					{customerRiskProfile && (<CustomerRiskProfileService service={service} />)}
					{validatePortabilityPP && (<ValidatePortabilityPPService service={service} />)}
					{portabilityIn && (<PortabilityInService service={service} />)}
					{requestNIP && (<RequestNIPService service={service} />)}
					{getSimulation && (<GetSimulationService service={service} />)}
					{productListPromise && (<ProductListPromiseService service={service} />)}
					{requestsFilters && (<RequestsFiltersService service={service} />)}
					{saveNip && (<SaveNipService service={service} />)}
					{statusNip && (<StatusNipService service={service} />)}
					{openIdConnectToken && (<OpenIdConnectTokenService service={service} />)}
					{tokenOauthTwoV1 && (<TokenOauthTwoV1Service service={service} />)}
					{msCusAccoInfoEcom && (<MSCusAccoInfoEcomService service={service} />)}
					{consultEventsStatus && (<ConsultEventsStatusService service={service} />)}
					{rsBusInteQryCondbyCred && (<RSBusInteQryCondbyCredService service={service} />)}
					{rsBusInteAskSurCr && (<RSBusInteAskSurCrService service={service} />)}

					{getBillCyclesService && (<GetBillCyclesService service={service} />)}
					{createAccountManagement && (<CreateAccountManagementSOAP service={service} />)}
					{b2b2cMsSecurityEntityAuthUser && <B2B2CMsSecurityEntityAuthUserService service={service} />}
					{b2b2cOrganizationProfileAgent && <B2B2COrganizationProfileAgentService service={service} />}
					{b2b2cOrganizationProfileCreditLimit && <B2B2COrganizationProfileCreditLimitService service={service} />}
					{b2b2cValidatePricePrOfPri && <B2B2CValidatePricePrOfPriService service={service} />}
					{b2b2cCRSOrganizationOrderCreate && <B2B2CRSOrganizationOrderCreateService service={service} />}
					{b2b2cRSOrganizationOrderModify && <B2B2CRSOrganizationOrderModifyService service={service} />}
					{b2b2cRSOrganizationOrderTrace && <B2B2CRSOrganizationOrderTraceService service={service} />}
					{b2b2cConsultarTransaccion && <B2B2CConsultarTransaccionService service={service} />}
					{b2b2cGatewayHistoricoPagos && <B2B2CGatewayHistoricoPagosService service={service} />}
					{b2b2cGatewayTransaccionPagos && <B2B2CGatewayTransaccionPagosService service={service} />}
					{b2b2cRSOrganizationPaymentRegister && <B2B2CRSOrganizationPaymentRegisterService service={service} />}
					{b2b2cRSOrganizationBillingDebtPastDue && <B2B2CRSOrganizationBillingDebtPastDueService service={service} />}
					{b2b2cQuerryPendingBillsToPayGetPortfolioPse && <B2B2CQuerryPendingBillsToPayGetPortfolioPseService service={service} />}
					{b2b2cConsultLogsAutomaticLog && <B2B2CConsultLogsAutomaticLogService service={service} />}
					{b2b2cEXPWSUserInformationShopAGetUserInfo && <B2B2CEXPWSUserInformationShopAGetUserInfoService service={service} />}
					{b2b2cEXPWSTransferShopAUpdateOperationTransfer && <B2B2CEXPWSTransferShopAUpdateOperationTransferService service={service} />}
					{b2b2cEXPWSTransferShopAGetComprobateStateTransfer && <B2B2CEXPWSTransferShopAGetComprobateStateTransferService service={service} />}

					{soapB2b2cValidationParamWebPC && <SoapB2b2cValidationParamWebPCService service={service} />}
					{soapB2b2cStartPayment && <SoapB2b2cStartPaymentService service={service} />}
					{soapB2b2cUpdatePaymentPSE && <SoapB2b2cUpdatePaymentPSEService service={service} />}

					{soapB2b2cGenerarOTPTransaccionalCanal && <SoapB2b2cGenerarOTPTransaccionalCanalService service={service} />}
					{soapB2b2cValidarOTPUsuario && <SoapB2b2cValidarOTPUsuarioService service={service} />}

					{soapB2b2cGetSapCustomerID && <SoapB2b2cGetSapCustomerIDService service={service} />}
					{soapB2b2cGetSectorCenters && <SoapB2b2cGetSectorCentersService service={service} />}
					{soapB2b2cGetRecipientsMerchandise && <SoapB2b2cGetRecipientsMerchandiseService service={service} />}
					{soapB2b2cGetCommercialPortalParameters && <SoapB2b2cGetCommercialPortalParametersService service={service} />}

					{soapB2b2cGetAssociatedStores && <SoapB2b2cGetAssociatedStoresService service={service} />}
					{soapB2b2cGetInvoiceRecipients && <SoapB2b2cGetInvoiceRecipientsService service={service} />}
					{soapB2b2cGetDataRechargeStock && <SoapB2b2cGetDataRechargeStockService service={service} />}
					{soapB2b2cGetApplicantsData && <SoapB2b2cGetApplicantsDataService service={service} />}

					{soapB2b2cTicketPending && <SoapB2b2cTicketPendingService service={service} />}
					{soapB2b2cDistributorBudgetPC && <SoapB2b2cDistributorBudgetPCService service={service} />}
					{soapB2b2cCreditLimitPC && <SoapB2b2cCreditLimitPCService service={service} />}
					{soapB2b2cExpiredPortfolioOrderPC && <SoapB2b2cExpiredPortfolioOrderPCService service={service} />}
					{soapB2b2cGetPortfolioPse && <SoapB2b2cGetPortfolioPseService service={service} />}
					{soapB2b2cGetComprobateStateTransfer && <SoapB2b2cGetComprobateStateTransferService service={service} />}
					{soapB2b2cUpdateOperationTransfer && <SoapB2b2cUpdateOperationTransferService service={service} />}

					{soapB2b2cCreatePortalOrder && <SoapB2b2cCreatePortalOrderService service={service} />}
					{soapB2b2cAutomaticLog && <SoapB2b2cAutomaticLogService service={service} />}
					{soapB2b2cGetUserInfo && <SoapB2b2cGetUserInfoService service={service} />}
					{rsProMetrSKUTermB2B2C && <RSProMetrSKUTermB2B2CService service={service} />}
					{validatePricePrOfPri && <ValidatePricePrOfPriService service={service} />}
				</div>
			</div>
		</div>
	);
};
export default ParameterCrud;
